import React, { Component } from 'react';
import {
    Grid, Paper, Typography, Chip, FormControl, InputLabel, Select, MenuItem, Button,
    Table, TableBody, TableCell, TableHead, TableRow, TextField, InputAdornment, CircularProgress,
    Hidden,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import SearchIcon from '@material-ui/icons/Search';
import GetAppIcon from '@material-ui/icons/GetApp';
import PersonSearchIcon from '@material-ui/icons/PermContactCalendar';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ReactExport from 'react-data-export';
import moment from 'moment';
import TareasTerminadas from '../../../general/TareasTerminadas';
import emma_w from './../../../../global/imagenes/emma_w.png';
import { buscarEstudiantes, fetchSolicitudesEstudianteBienestar } from '../services/bienestarDetalleService';
import DialogAtencionTrazabilidad, { ChipAsistencia } from './DialogAtencionTrazabilidad';
import {
    PERIODO_TODOS,
    PERIODOS_TRAZABILIDAD,
    ORIGENES_TRAZABILIDAD,
    NO_ASISTIO,
    ETIQUETA_ASISTENCIA,
    fetchTrazabilidadEstudiante,
    solicitudAAtencion,
} from '../services/consultaEstudianteMock';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const COLORES_ESTADO_TRAZABILIDAD = {
    'Agendado': { backgroundColor: '#fcd116', color: '#6b5500' },
    'Atendido': { backgroundColor: '#d3e7f9', color: '#0a3a6b' },
    'Cierre': { backgroundColor: '#d6ecd9', color: '#14501a' },
};

const SIN_ATENDER = 'Sin atender';
const MIN_CARACTERES_BUSQUEDA = 4;

const ESTILO_CONTENEDOR = { padding: '2% 2% 0% 2%' };
const ESTILO_CARD = {
    borderRadius: 12,
    border: '1px solid #dcdcdc',
    boxShadow: '0 1px 3px rgba(16, 24, 40, 0.10)',
    marginBottom: 14,
    overflow: 'hidden',
};
const ESTILO_TH = { fontSize: 12, color: '#4a4a4a', padding: '10px 14px', borderBottom: '1px solid #dcdcdc', backgroundColor: '#f7f7f7' };
const ESTILO_TD = { fontSize: 13, padding: '12px 14px', borderBottom: '1px solid #eaeaea' };
const ESTILO_TD_SEC = { ...ESTILO_TD, color: '#4f4f4f' };
const ESTILO_IDENTIDAD = { fontSize: 12.5, color: '#5f5f5f', overflowWrap: 'anywhere' };
const ESTILO_AVATAR = {
    width: 40, height: 40, borderRadius: '50%', flex: '0 0 40px',
    backgroundColor: '#fdeeee', color: '#c8102e',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14,
};
const ESTILO_CHIP = { height: 24, fontSize: 12, borderRadius: 12 };
const ESTILO_CHIP_ORIGEN = { height: 22, fontSize: 11, borderRadius: 11, backgroundColor: '#e8e8e8', color: '#424242' };
const COLOR_RESUMEN_TOTAL = { backgroundColor: '#dbeafb', color: '#0a3a6b' };
const COLOR_RESUMEN_ATENDIDAS = { backgroundColor: '#ddf0dd', color: '#255914' };
const COLOR_RESUMEN_PENDIENTES = { backgroundColor: '#fbeec4', color: '#755a03' };

// Las columnas del reporte: los datos del estudiante se repiten en cada fila.
const COLUMNAS_REPORTE = [
    { label: 'Identificación', id: 'identificacion' },
    { label: 'Nombre', id: 'nombre' },
    { label: 'Contacto', id: 'contacto' },
    { label: 'Cohorte', id: 'cohorte' },
    { label: 'Programa', id: 'programa' },
    { label: 'Periodo', id: 'periodo' },
    { label: 'Quién remite', id: 'quien_remite' },
    { label: 'Opción seleccionada', id: 'opcion_seleccionada' },
    { label: 'Origen', id: 'origen_nombre' },
    { label: 'Estado', id: 'estado' },
    { label: 'Fecha de solicitud', id: 'fecha_solicitud' },
    { label: 'Fecha de atención', id: 'fecha_atencion' },
    { label: 'Asistencia', id: 'asistencia_texto' },
    { label: 'Motivo', id: 'motivo' },
    { label: 'Cierre', id: 'cierre' },
];

// Cuantas filas se muestran por origen antes de pedir ver el resto.
const FILAS_POR_GRUPO = 5;

const ESTILO_ACORDEON = {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '13px 16px', cursor: 'pointer', borderTop: '1px solid #eaeaea',
};
const ESTILO_NOMBRE_ORIGEN = { fontSize: 13.5, flex: 1, minWidth: 120 };
const ESTILO_RESUMEN_ORIGEN = { fontSize: 11.5, color: '#6f6f6f' };
const ESTILO_VER_TODAS = { fontSize: 12, color: '#0a3a6b', cursor: 'pointer', padding: '10px 16px 12px 42px' };
const ESTILO_TD_SERVICIO = {
    fontSize: 12, color: '#4a4a4a', padding: '8px 14px',
    borderBottom: '1px solid #eaeaea', backgroundColor: '#fafafa',
};

// Mismo contenedor centrado que usa el resto del modulo (ver pintarInicioProcesos).
function Contenedor({ children }) {
    return (
        <div style={ESTILO_CONTENEDOR}>
            <Grid container direction="row" spacing={1} justify="center">
                <Grid item xs={12} sm={12} md={12} lg={10}>
                    {children}
                </Grid>
            </Grid>
        </div>
    );
}

const nombreCompleto = (p) => [p?.primer_nombre, p?.segundo_nombre, p?.primer_apellido, p?.segundo_apellido]
    .filter(Boolean).join(' ').trim();

const iniciales = (nombre) => String(nombre || '')
    .split(' ').filter(Boolean).slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase())
    .join('');

export default class ConsultaEstudiante extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opciones: [],
            buscando: false,
            texto: '',
            persona: null,
            estudiante: null,
            atenciones: [],
            periodo: PERIODO_TODOS,
            estadoFiltro: 'todos',
            cargando: false,
            atencionAbierta: null,
            abiertos: [],
            verTodas: [],
        };
        this.debounce = null;
    }

    componentWillUnmount() {
        if (this.debounce) clearTimeout(this.debounce);
    }

    buscar = (texto) => {
        this.setState({ texto });
        if (this.debounce) clearTimeout(this.debounce);
        if (texto.trim().length < MIN_CARACTERES_BUSQUEDA) {
            this.setState({ opciones: [], buscando: false });
            return;
        }
        this.setState({ buscando: true });
        this.debounce = setTimeout(async () => {
            const opciones = await buscarEstudiantes(texto);
            this.setState({ opciones, buscando: false });
        }, 350);
    };

    seleccionarPersona = (persona) => {
        if (!persona) {
            this.setState({ persona: null, estudiante: null, atenciones: [], estadoFiltro: 'todos', abiertos: [], verTodas: [] });
            return;
        }
        this.setState({ persona, estadoFiltro: 'todos', abiertos: [], verTodas: [] }, this.cargarTrazabilidad);
    };

    cambiarPeriodo = (periodo) => this.setState({ periodo });

    cargarTrazabilidad = async () => {
        const { persona } = this.state;
        if (!persona) return;
        this.setState({ cargando: true });
        const [resp, solicitudes] = await Promise.all([
            fetchTrazabilidadEstudiante({ persona, periodo: PERIODO_TODOS }),
            fetchSolicitudesEstudianteBienestar(persona.id),
        ]);
        const atenciones = (resp ? resp.atenciones : [])
            .concat(solicitudes.map(solicitudAAtencion))
            .sort((a, b) => b.orden - a.orden);
        const primero = ORIGENES_TRAZABILIDAD.find((o) => atenciones.some((a) => a.origen === o.codigo));
        this.setState({
            estudiante: resp ? resp.estudiante : null,
            atenciones,
            abiertos: primero ? [primero.codigo] : [],
            verTodas: [],
            cargando: false,
        });
    };

    atencionesFiltradas = () => {
        const { atenciones, estadoFiltro, periodo } = this.state;
        return atenciones
            .filter((a) => periodo === PERIODO_TODOS || a.periodo === periodo)
            .filter((a) => estadoFiltro === 'todos' || a.estado === estadoFiltro);
    };

    // Un grupo por origen, siempre los cuatro: un origen en cero tambien informa.
    grupos = () => {
        const filtradas = this.atencionesFiltradas();
        return ORIGENES_TRAZABILIDAD.map((o) => ({
            ...o,
            filas: filtradas.filter((a) => a.origen === o.codigo),
        }));
    };

    resumenGrupo = ({ filas, integrado }) => {
        if (filas.length === 0) {
            return integrado ? 'Sin atenciones registradas' : 'Pendiente de integración';
        }
        const atendidas = filas.filter((a) => a.fecha_atencion !== SIN_ATENDER).length;
        const sinAsistir = filas.filter((a) => a.asistencia === NO_ASISTIO).length;
        const partes = [];
        if (atendidas) partes.push(`${atendidas} ${atendidas === 1 ? 'atendida' : 'atendidas'}`);
        if (sinAsistir) partes.push(`${sinAsistir} sin asistir`);
        return partes.join(' · ') || `${filas.length} sin atender`;
    };

    // Dentro de un origen las atenciones se juntan por servicio: con varios
    // semestres a la vista, mezclarlas por fecha se lee como una lista revuelta.
    subgrupos = (filas) => {
        const orden = [];
        const mapa = new Map();
        filas.forEach((a) => {
            if (!mapa.has(a.opcion_seleccionada)) {
                mapa.set(a.opcion_seleccionada, []);
                orden.push(a.opcion_seleccionada);
            }
            mapa.get(a.opcion_seleccionada).push(a);
        });
        return orden
            .map((nombre) => ({ nombre, filas: mapa.get(nombre) }))
            .sort((a, b) => b.filas.length - a.filas.length);
    };

    // Se recortan servicios completos, nunca a mitad de uno: un subtitulo que
    // dice 3 y muestra 2 filas se lee como un error.
    subgruposVisibles = (subgrupos, todas) => {
        if (todas) return subgrupos;
        const visibles = [];
        let acumuladas = 0;
        for (const sub of subgrupos) {
            if (visibles.length > 0 && acumuladas >= FILAS_POR_GRUPO) break;
            visibles.push(sub);
            acumuladas += sub.filas.length;
        }
        return visibles;
    };

    alternar = (codigo, lista) => this.setState((prev) => ({
        [lista]: prev[lista].includes(codigo)
            ? prev[lista].filter((c) => c !== codigo)
            : prev[lista].concat(codigo),
    }));

    abrirAtencion = (atencion) => this.setState({ atencionAbierta: atencion });

    cerrarAtencion = () => this.setState({ atencionAbierta: null });

    estadosDisponibles = () => [...new Set(this.state.atenciones.map((a) => a.estado))].filter(Boolean);

    // Los periodos salen de lo que trajo el estudiante, no de una lista fija:
    // sus solicitudes reales pueden ser de semestres que no estan en el mock.
    periodosDisponibles = () => [...new Set(
        this.state.atenciones.map((a) => a.periodo).concat(PERIODOS_TRAZABILIDAD),
    )].filter(Boolean).sort().reverse();

    // Filas planas para el reporte: cada atencion repite los datos del estudiante.
    filasReporte = () => {
        const { estudiante } = this.state;
        return this.atencionesFiltradas().map((a) => ({
            ...a,
            asistencia_texto: ETIQUETA_ASISTENCIA[a.asistencia] || 'No aplica',
            identificacion: estudiante?.identificacion || '',
            nombre: estudiante?.nombre || '',
            contacto: estudiante?.contacto || '',
            cohorte: estudiante?.cohorte || '',
            programa: estudiante?.programa || '',
        }));
    };

    pintarBuscador = () => {
        const { opciones, buscando, persona, texto } = this.state;
        const sinResultados = texto.trim().length >= MIN_CARACTERES_BUSQUEDA && !buscando
            ? 'No se encontraron estudiantes'
            : `Escribe al menos ${MIN_CARACTERES_BUSQUEDA} caracteres`;
        return (
            <Paper elevation={0} style={{ ...ESTILO_CARD, padding: '10px 14px' }}>
                <Autocomplete
                    options={opciones}
                    value={persona}
                    loading={buscando}
                    filterOptions={(x) => x}
                    noOptionsText={sinResultados}
                    loadingText="Buscando..."
                    getOptionLabel={(o) => nombreCompleto(o)}
                    getOptionSelected={(o, v) => o.id === v.id}
                    onInputChange={(e, valor, motivo) => { if (motivo === 'input') this.buscar(valor); }}
                    onChange={(e, valor) => this.seleccionarPersona(valor)}
                    renderOption={(o) => (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div style={{ ...ESTILO_AVATAR, width: 30, height: 30, flex: '0 0 30px', fontSize: 11 }}>
                                {iniciales(nombreCompleto(o))}
                            </div>
                            <div style={{ minWidth: 0 }}>
                                <Typography style={{ fontSize: 13 }}>{nombreCompleto(o)}</Typography>
                                <Typography style={{ fontSize: 11, color: '#6f6f6f' }}>
                                    {[o.identificacion, o.correo].filter(Boolean).join(' · ')}
                                </Typography>
                            </div>
                        </div>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Busca por documento, correo o nombre del estudiante"
                            inputProps={{ ...params.inputProps, style: { fontSize: 14 } }}
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ color: '#6f6f6f' }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <>
                                        {buscando && <CircularProgress color="inherit" size={18} />}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            </Paper>
        );
    };

    pintarVacio = () => (
        <Paper elevation={0} style={{ ...ESTILO_CARD, padding: '52px 16px', textAlign: 'center', backgroundColor: '#fafafa' }}>
            <PersonSearchIcon style={{ fontSize: 44, color: '#b0b0b0' }} />
            <Typography style={{ fontSize: 13.5, color: '#6f6f6f', marginTop: 10 }}>
                Busca un estudiante para ver su trazabilidad de atenciones.
            </Typography>
        </Paper>
    );

    pintarEncabezado = () => {
        const { estudiante } = this.state;
        // Los contadores siguen al filtro: si no, dicen 24 y la lista muestra 5.
        const atenciones = this.atencionesFiltradas();
        const pendientes = atenciones.filter((a) => a.fecha_atencion === SIN_ATENDER).length;
        const atendidas = atenciones.length - pendientes;
        const identidad = [
            estudiante.identificacion,
            estudiante.programa,
            estudiante.cohorte && `Cohorte ${estudiante.cohorte}`,
            estudiante.contacto,
            estudiante.correo,
        ].filter(Boolean).join('  ·  ');

        return (
            <Paper elevation={0} style={{ ...ESTILO_CARD, padding: '14px 16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <div style={ESTILO_AVATAR}>{iniciales(estudiante.nombre)}</div>
                    <div style={{ flex: 1, minWidth: 220 }}>
                        <Typography style={{ fontSize: 15.5, fontWeight: 500 }}>{estudiante.nombre}</Typography>
                        <Typography style={ESTILO_IDENTIDAD}>{identidad}</Typography>
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        <Chip size="small" label={`${atenciones.length} atenciones`} style={{ ...ESTILO_CHIP, ...COLOR_RESUMEN_TOTAL }} />
                        <Chip size="small" label={`${atendidas} atendidas`} style={{ ...ESTILO_CHIP, ...COLOR_RESUMEN_ATENDIDAS }} />
                        {pendientes > 0 && (
                            <Chip
                                size="small"
                                label={`${pendientes} ${pendientes === 1 ? 'pendiente' : 'pendientes'}`}
                                style={{ ...ESTILO_CHIP, ...COLOR_RESUMEN_PENDIENTES }}
                            />
                        )}
                    </div>
                </div>
            </Paper>
        );
    };

    pintarBarra = () => {
        const { periodo, estadoFiltro, estudiante } = this.state;
        const filas = this.filasReporte();
        return (
            <Grid
                container
                spacing={2}
                alignItems="flex-end"
                style={{ padding: '10px 14px', borderBottom: '1px solid #dcdcdc', margin: 0, width: '100%' }}
            >
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <FormControl fullWidth>
                        <InputLabel id="periodo-trazabilidad">Periodo</InputLabel>
                        <Select labelId="periodo-trazabilidad" value={periodo} onChange={(e) => this.cambiarPeriodo(e.target.value)}>
                            <MenuItem value={PERIODO_TODOS}>Todos</MenuItem>
                            {this.periodosDisponibles().map((p) => <MenuItem key={p} value={p}>{p}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={2}>
                    <FormControl fullWidth>
                        <InputLabel id="estado-trazabilidad">Estado</InputLabel>
                        <Select labelId="estado-trazabilidad" value={estadoFiltro} onChange={(e) => this.setState({ estadoFiltro: e.target.value })}>
                            <MenuItem value="todos">Todos</MenuItem>
                            {this.estadosDisponibles().map((e) => <MenuItem key={e} value={e}>{e}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm md style={{ textAlign: 'right' }}>
                    {filas.length > 0 && (
                        <ExcelFile
                            filename={`TRAZABILIDAD ${estudiante?.identificacion || ''} - ${moment().format('YYYY-MM-DD, h:mm a')}`}
                            element={(
                                <Button
                                    color="secondary"
                                    variant="outlined"
                                    size="small"
                                    startIcon={<GetAppIcon />}
                                    style={{ borderRadius: 8, textTransform: 'none' }}
                                >
                                    Descargar
                                </Button>
                            )}
                        >
                            <ExcelSheet data={filas} name="atenciones">
                                {COLUMNAS_REPORTE.map((c) => <ExcelColumn key={c.id} label={c.label} value={c.id} />)}
                            </ExcelSheet>
                        </ExcelFile>
                    )}
                </Grid>
            </Grid>
        );
    };

    chipEstado = (estado) => (
        <Chip
            size="small"
            label={estado}
            style={{ ...ESTILO_CHIP, height: 22, fontSize: 11, ...COLORES_ESTADO_TRAZABILIDAD[estado] }}
        />
    );

    textoAtencion = (fecha) => (fecha === SIN_ATENDER ? 'Sin registrar' : fecha);

    pintarTablaEscritorio = (subgrupos) => (
        <div style={{ overflowX: 'auto' }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell style={ESTILO_TH}>Periodo</TableCell>
                        <TableCell style={ESTILO_TH}>Quién remite</TableCell>
                        <TableCell style={ESTILO_TH}>Estado</TableCell>
                        <TableCell style={ESTILO_TH}>Solicitud</TableCell>
                        <TableCell style={ESTILO_TH}>Atención</TableCell>
                        <TableCell style={ESTILO_TH}>Asistencia</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {subgrupos.map((sub) => (
                        <React.Fragment key={sub.nombre}>
                            <TableRow>
                                <TableCell colSpan={6} style={ESTILO_TD_SERVICIO}>
                                    {`${sub.nombre}  ·  ${sub.filas.length}`}
                                </TableCell>
                            </TableRow>
                            {sub.filas.map((a) => (
                                <TableRow
                                    key={a.id}
                                    hover
                                    onClick={() => this.abrirAtencion(a)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <TableCell style={ESTILO_TD_SEC}>{a.periodo}</TableCell>
                                    <TableCell style={ESTILO_TD_SEC}>{a.quien_remite}</TableCell>
                                    <TableCell style={ESTILO_TD}>{this.chipEstado(a.estado)}</TableCell>
                                    <TableCell style={ESTILO_TD_SEC}>{a.fecha_solicitud}</TableCell>
                                    <TableCell style={a.fecha_atencion === SIN_ATENDER ? { ...ESTILO_TD, color: '#9a9a9a' } : ESTILO_TD_SEC}>
                                        {this.textoAtencion(a.fecha_atencion)}
                                    </TableCell>
                                    <TableCell style={ESTILO_TD}><ChipAsistencia asistencia={a.asistencia} /></TableCell>
                                </TableRow>
                            ))}
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </div>
    );

    // En pantallas pequenas la tabla de 6 columnas obliga a scroll horizontal:
    // cada atencion se pinta como tarjeta.
    pintarTarjetasMovil = (subgrupos) => (
        <div style={{ padding: '4px 12px 0' }}>
            {subgrupos.map((sub) => (
                <div key={sub.nombre}>
                    <Typography style={{ ...ESTILO_TD_SERVICIO, padding: '8px 4px', backgroundColor: 'transparent' }}>
                        {`${sub.nombre}  ·  ${sub.filas.length}`}
                    </Typography>
                    {sub.filas.map((a) => (
                        <div
                            key={a.id}
                            onClick={() => this.abrirAtencion(a)}
                            style={{ padding: '12px 0', borderBottom: '1px solid #eaeaea', cursor: 'pointer' }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                                <Typography style={{ fontSize: 13, flex: 1, minWidth: 0, color: '#4f4f4f' }}>{a.periodo}</Typography>
                                {this.chipEstado(a.estado)}
                                <ChipAsistencia asistencia={a.asistencia} />
                            </div>
                            <Typography style={{ fontSize: 12.5, color: '#4f4f4f' }}>
                                {`Remite: ${a.quien_remite}`}
                            </Typography>
                            <Typography style={{ fontSize: 12.5, color: '#4f4f4f' }}>
                                {`Solicitud: ${a.fecha_solicitud}`}
                                <span style={{ color: a.fecha_atencion === SIN_ATENDER ? '#c4c4c4' : '#6b6b6b' }}>
                                    {`  ·  Atención: ${this.textoAtencion(a.fecha_atencion)}`}
                                </span>
                            </Typography>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );

    pintarGrupo = (grupo) => {
        const { abiertos, verTodas } = this.state;
        const abierto = abiertos.includes(grupo.codigo);
        const todas = verTodas.includes(grupo.codigo);
        const vacio = grupo.filas.length === 0;
        const subgrupos = this.subgrupos(grupo.filas);
        const visibles = this.subgruposVisibles(subgrupos, todas);
        const ocultas = grupo.filas.length - visibles.reduce((n, s) => n + s.filas.length, 0);
        const Icono = abierto ? ExpandMoreIcon : ChevronRightIcon;
        const atenuado = vacio ? { color: '#9a9a9a' } : null;

        return (
            <div key={grupo.codigo}>
                <div
                    style={{ ...ESTILO_ACORDEON, cursor: vacio ? 'default' : 'pointer' }}
                    onClick={() => !vacio && this.alternar(grupo.codigo, 'abiertos')}
                >
                    <Icono style={{ fontSize: 18, color: vacio ? '#c4c4c4' : '#6f6f6f' }} />
                    <Typography style={{ ...ESTILO_NOMBRE_ORIGEN, ...atenuado }}>{grupo.nombre}</Typography>
                    <Typography
                        style={{
                            ...ESTILO_RESUMEN_ORIGEN,
                            ...(grupo.filas.some((a) => a.asistencia === NO_ASISTIO) ? { color: '#8c1c1c' } : atenuado),
                        }}
                    >
                        {this.resumenGrupo(grupo)}
                    </Typography>
                    <Chip
                        size="small"
                        label={grupo.filas.length}
                        style={{ ...ESTILO_CHIP_ORIGEN, ...(vacio ? { color: '#9a9a9a' } : null) }}
                    />
                </div>
                {abierto && !vacio && (
                    <>
                        <Hidden smDown>{this.pintarTablaEscritorio(visibles)}</Hidden>
                        <Hidden mdUp>{this.pintarTarjetasMovil(visibles)}</Hidden>
                        {(ocultas > 0 || todas) && (
                            <Typography
                                style={ESTILO_VER_TODAS}
                                onClick={() => this.alternar(grupo.codigo, 'verTodas')}
                            >
                                {todas
                                    ? 'Ver menos'
                                    : `Ver ${ocultas} ${ocultas === 1 ? 'atención más' : 'atenciones más'}`}
                            </Typography>
                        )}
                    </>
                )}
            </div>
        );
    };

    pintarTabla = () => {
        const { atenciones, estadoFiltro } = this.state;
        if (atenciones.length > 0 && this.atencionesFiltradas().length === 0) {
            return (
                <Typography style={{ fontSize: 13.5, color: '#6f6f6f', padding: '40px 16px', textAlign: 'center' }}>
                    Ninguna atención coincide con el estado seleccionado.
                </Typography>
            );
        }
        return <div>{this.grupos().map(this.pintarGrupo)}</div>;
    };

    pintarResultado = () => {
        const { cargando, estudiante } = this.state;
        if (cargando && !estudiante) {
            return (
                <Paper elevation={0} style={{ ...ESTILO_CARD, padding: '30px 16px' }}>
                    <TareasTerminadas mensaje="Cargando.." marginTop="2%" imagen={emma_w} widthImg="7%" cargando={true} />
                </Paper>
            );
        }
        if (!estudiante) return null;
        return (
            <>
                {this.pintarEncabezado()}
                <Paper elevation={0} style={ESTILO_CARD}>
                    {this.pintarBarra()}
                    {this.pintarTabla()}
                </Paper>
            </>
        );
    };

    render() {
        const { persona, atencionAbierta } = this.state;
        return (
            <Contenedor>
                {this.pintarBuscador()}
                {persona ? this.pintarResultado() : this.pintarVacio()}
                <DialogAtencionTrazabilidad
                    open={Boolean(atencionAbierta)}
                    atencion={atencionAbierta}
                    onClose={this.cerrarAtencion}
                    chipEstado={this.chipEstado}
                />
            </Contenedor>
        );
    }
}
